import React, { useMemo } from "react";
import classes from "./LabStatusOverview.module.css";

export default function LabStatusOverview({ STATUS_COLORS, labData }) {
  // Calculate counts
  const summary = useMemo(() => {
    if (!labData || labData.length === 0) {
      return { total: 0, counts: {} };
    }

    const total = labData.length;
    const counts = Object.keys(STATUS_COLORS).reduce((acc, status) => {
      acc[status] = labData.filter((l) => l.status === status).length;
      return acc;
    }, {});

    return { total, counts };
  }, [labData, STATUS_COLORS]); // ✅ recalc when labData changes

  if (!labData || labData.length === 0) {
    return <p>Loading lab data...</p>;
  }

  return (
    <div className={`${classes.container} px-3 mt-3`}>
      <h5 className="mb-3">Laboratory Status Overview</h5>
      {Object.entries(summary.counts).map(([status, count]) => {
        const percent = summary.total
          ? Math.round((count / summary.total) * 100)
          : 0;
        return (
          <div key={status} className="mb-4">
            <div className="d-flex align-items-center justify-content-between mb-1">
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    display: "inline-block",
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background: STATUS_COLORS[status],
                  }}
                />
                <p>{status}</p>
              </div>
              <div className="d-flex align-items-baseline gap-1">
                <p>{count}</p>{" "}
                <span className={`${classes.percentage}`}>({percent}%)</span>
              </div>
            </div>
            <div
              className="progress"
              style={{
                height: 10,
                backgroundColor: "#f3f4f6",
                borderRadius: 10,
              }}
            >
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${percent}%`,
                  backgroundColor: STATUS_COLORS[status],
                  borderRadius: 10,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
